import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Report from './views/Report.vue'

import Offers from './views/Offers.vue'
import Offer from './views/Offer.vue'

import Amendments from './views/Amendments.vue'
import Amendment from './views/Amendment.vue'
import AdminCost from './views/AdminCost.vue'


Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/report',
            name: 'Report',
            component: Report
        },
        {
            path: '/offers',
            name: 'Offers',
            component: Offers
        },
        {
            path: '/offers/new',
            name: 'CreateOffer',
            component: Offer
        },
        {
            path: '/offers/:id',
            name: 'EditOffer',
            component: Offer
        },
        {
            path: '/amendments',
            name: 'Amendments',
            component: Amendments
        },
        {
            path: '/amendments/new',
            name: 'CreateAmendment',
            component: Amendment
        },
        {
            path: '/amendments/:id',
            name: 'EditAmendment',
            component: Amendment
        },
        {
            path: '/admincost',
            name: 'AdminCost',
            component: AdminCost
        },
        {
            path: '/',
            name: 'Login',
            component: Login
        }
    ]
})
